import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, TextField } from "@mui/material";
import { useAppContext } from "../AppContext";
import React from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { LoadingButton } from "@mui/lab";

function Action() {
    const { values } = useAppContext();
    const [cancelConfirmation, setCancelConfirmation] = React.useState(false);
    const [reattempt, setReattempt] = React.useState(false);
    const [actionTaken, setActionTaken] = React.useState(false);

    const { handleSubmit, register, formState: { isSubmitting, errors } } = useForm();

    if (!values || !values.otpVerified || !values.askForVerification) return null;

    const cancelOrder = async () => {
        try {
            const serviceUrl = `${window.REACT_APP_SERVICE_ENDPOINT}order/tracking/ndrActionUpdate`
            await axios.post(serviceUrl, {
                loggedInUser: 'trackingPage',
                ndr_waybills_data: [{
                    waybill: values.orderDetails.waybill,
                    action: 'INITIATE_RTO'
                }]
            });
            toast.success('Order cancelled successfully!');
            setActionTaken(true);
        } catch (err) {
            console.error(err);
            toast.error(err?.response?.data?.message || 'Someting went wrong! Please try again later');
        } finally {
            setCancelConfirmation(false);
        }
    }

    const onSubmitHandler = async (formData) => {
        try {

            const request = {};

            Object.keys(formData).forEach((key) => {
                if (formData[key]) {
                    request[key] = formData[key];
                }
            })

            const serviceUrl = `${window.REACT_APP_SERVICE_ENDPOINT}order/tracking/ndrActionUpdate`
            await axios.post(serviceUrl, {
                loggedInUser: 'trackingPage',
                ndr_waybills_data: [{
                    waybill: values.orderDetails.waybill,
                    action: 'REATTEMPT',
                    ...request
                }]
            });

            toast.success('Re-attempt requested!');
            setReattempt(false);
            setActionTaken(true);
        } catch (err) {
            toast.error(err?.response?.data?.message || 'Something went wrong! Please try again later');
            console.error(err);
        }
    }

    return (
        <>
            <Dialog open={cancelConfirmation} onClose={() => setCancelConfirmation(false)}>
                <DialogTitle>
                    Order Cancellation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                        Are you sure you want to cancel the order?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCancelConfirmation(false)}>Go Back</Button>
                    <Button onClick={cancelOrder} color="error" variant="contained" disableElevation>Yes, Cancel Order</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={reattempt} onClose={() => setReattempt(false)}>
                <form onSubmit={handleSubmit(onSubmitHandler)}>
                    <DialogTitle>
                        Re-attempt Request
                    </DialogTitle>
                    <DialogContent>
                        <Alert severity="info">
                            Please provide the following information to help us make delivery attempts more efficiently, ensuring that your package reaches you in a timely and convenient manner. This will allow us to avoid delays and improve our service to meet your delivery needs.
                        </Alert>
                        <Grid container spacing={2} sx={{ mt: 2 }}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Phone Number"
                                    placeholder="Please enter a valid phone number"
                                    fullWidth
                                    error={!!errors.phone_number}
                                    type="tel"
                                    {...register('phone_number', {
                                        required: false,
                                        pattern: {
                                            value: /^[0-9]{10}$/,
                                            message: 'Phone number must be exactly 10 digits',
                                        },
                                        maxLength: {
                                            value: 10,
                                            message: 'Phone number must be exactly 10 digits',
                                        },
                                        minLength: {
                                            value: 10,
                                            message: 'Phone number must be exactly 10 digits',
                                        }
                                    })}
                                    {...(errors.phone_number ? { helperText: errors.phone_number.message } : {})}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Pincode"
                                    placeholder="Please enter a valid pincode"
                                    fullWidth
                                    error={!!errors.drop_pincode}
                                    {...register('drop_pincode', {
                                        required: false,
                                        pattern: {
                                            value: /^[0-9]{6}$/,
                                            message: 'Pincode must be exactly 6 digits',
                                        },
                                        maxLength: {
                                            value: 6,
                                            message: 'Pincode must be exactly 6 digits',
                                        },
                                        minLength: {
                                            value: 6,
                                            message: 'Pincode must be exactly 6 digits',
                                        }
                                    })}
                                    {...(errors.drop_pincode ? { helperText: errors.drop_pincode.message } : {})}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <TextField
                                    label="Address"
                                    placeholder="Please enter complete delivery address"
                                    fullWidth
                                    error={!!errors.address}
                                    {...register('address', { required: false })}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Landmark"
                                    placeholder="Enter a nearby landmark"
                                    fullWidth
                                    error={!!errors.landmark}
                                    {...register('landmark', { required: false })}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    label="Preferred Date"
                                    fullWidth
                                    type="date"
                                    error={!!errors.preferred_date}
                                    InputLabelProps={{ shrink: true }}
                                    {...register('preferred_date', { required: false })}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setReattempt(false)}>Go Back</Button>
                        <LoadingButton variant="contained" loading={isSubmitting} type="submit" disableElevation>Submit</LoadingButton>
                    </DialogActions>
                </form>
            </Dialog >
            {(values?.orderDetails?.ndrStatus === 'REPORTED') && !actionTaken && (
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button onClick={() => setCancelConfirmation(true)} size="small" variant="contained" color="error" disableElevation>Cancel</Button>
                    <Button onClick={() => setReattempt(true)} size="small" variant="contained" disableElevation>Re-attempt</Button>
                </Box>
            )}
        </>
    )
}

export default Action;